import { useLocalStorage } from 'usehooks-ts';

export function useHideBrowserWarning() {
  const [hideBrowserWarning, setHideBrowserWarning] = useLocalStorage('hideBrowserWarning', false);
  const dismissBrowserWarning = () => setHideBrowserWarning(true);
  return { hideBrowserWarning, dismissBrowserWarning };
}

export function useMaintenanceWarning() {
  const [hideMaintenanceWarning, setHideMaintenanceWarning] = useLocalStorage('hideMaintenanceWarning', false);
  const [maintenanceWarningVersion, setMaintenanceWarningVersion] = useLocalStorage('maintenanceWarningVersion', '');
  const dismissMaintenanceWarning = (version: string) => {
    setHideMaintenanceWarning(true);
    setMaintenanceWarningVersion(version);
  };
  return { hideMaintenanceWarning, maintenanceWarningVersion, dismissMaintenanceWarning };
}
